module.exports = __webpack_public_path__ + "static/media/sendToBack.57b76321.svg";